import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BarcodeDetector, setZXingModuleOverrides } from 'barcode-detector/ponyfill';

import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';

// Le wasm ZXing est servi en local depuis src/assets (commité dans git)
// plutôt que depuis le CDN jsDelivr : la borne iPad reste autonome.
setZXingModuleOverrides({
    locateFile: (path: string) => `/assets/${path}`
});

@Component({
    selector: 'app-qr-scanner',
    standalone: true,
    imports: [TranslatePipe],
    templateUrl: './qr-scanner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class QrScannerComponent implements OnInit, OnDestroy {

    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

    @Output() scanned = new EventEmitter<string>();

    stream: MediaStream | null = null;
    cameraReady = false;
    cameraError = false;

    private detector = new BarcodeDetector({ formats: ['qr_code'] });
    private scanTimer: ReturnType<typeof setInterval> | null = null;
    private scanInProgress = false;
    private stopped = false;

    ngOnInit(): void {
        this.startCamera();
    }

    ngOnDestroy(): void {
        this.stopScanner();
    }

    async startCamera(): Promise<void> {
        try {
            this.cameraError = false;
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } }
            });
            setTimeout(() => {
                if (this.videoElement?.nativeElement) {
                    this.videoElement.nativeElement.srcObject = this.stream;
                    this.videoElement.nativeElement.play();
                    this.cameraReady = true;
                    this.startScanLoop();
                }
            }, 100);
        } catch (err) {
            console.error('Camera access error:', err);
            this.cameraError = true;
        }
    }

    private startScanLoop(): void {
        if (this.scanTimer !== null) return;

        this.scanTimer = setInterval(async () => {
            if (this.scanInProgress || this.stopped) return;

            const video = this.videoElement?.nativeElement;
            if (!video || video.readyState < 2) return;

            this.scanInProgress = true;
            try {
                const results = await this.detector.detect(video);
                const code = results?.[0]?.rawValue;
                if (code) {
                    this.scanned.emit(code);
                }
            } catch (err) {
                console.warn('QR detect error:', err);
            } finally {
                this.scanInProgress = false;
            }
        }, 250);
    }

    stopScanner(): void {
        this.stopped = true;
        if (this.scanTimer !== null) {
            clearInterval(this.scanTimer);
            this.scanTimer = null;
        }
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
    }
}
